import React from 'react'
import { render } from 'react-dom'
import registerServiceWorker from './registerServiceWorker'

import './css/app.scss';
import './css/App.css'
import store from './js/store/'
import Root from './js/components/Root';

window.store = store;

render(
  <Root store={store} />,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js